import React, { Component } from 'react';
//import Config from './Config';
import ColumnSelector from './ColumnSelector';
import { Scrollbars } from 'react-custom-scrollbars';
import './css/List.css';
import ListFilter from './ListFilter';
import PageState from './PageState';
//import FX from './functions/functions';
class List extends Component {
  constructor(props){
    super(props);
    var str_filter = this.props.model.str_filter;
    var filter = this.props.model.filter.map((filter,i) => {
      var options = [{description: filter.offTitle}].concat( filter.options).map((opt, j)=>{
        if(opt){
        return opt.id;
        }
        else {
        return false;
        }
      });
      return options;
    });
    this.props.root.onScroll = (e) => {
      console.log(e)
    }
    filter = this.props.model.filter;
    this.state = {columns:this.props.model.columns, filter: filter, filterText:'', str_filter:str_filter, sortList: []};
  }
  componentDidMount(){
    if( document.querySelectorAll('.List').length === 1){
      window.addEventListener("scroll", this.decapitate);
      window.addEventListener("resize", this.decapitate);
    }
  }
  clearFilter = () => {
    if(document.getElementById("filter_text")){
		    this.setState({filterText :''})
    }
  }
  decapitate = (e) => {
    if( document.querySelectorAll('.List').length === 1){
      var tb, ll;

      (tb = document.querySelector('.TopBar').getBoundingClientRect());
      (ll = document.querySelectorAll('.List')[0].getBoundingClientRect());
      if(tb.height - ll.y  > 60){
        (document.querySelectorAll('.List thead')[0].style.position='fixed');
        (document.querySelectorAll('.List thead')[0].style.display='block');
      }
      else {
        (document.querySelectorAll('.List thead')[0].style.display='none');
        (document.querySelectorAll('.List thead')[0].style.position='relative');
      }
      var list;
      var head;
      head = document.querySelectorAll('.List thead tr th');
      (list = document.querySelectorAll('.List tr:nth-child(2) td'));
      for(var i = 0; i < list.length; i++){
        document.querySelector('.List thead').style.left = ll.left + 'px';
        document.querySelector('.List thead').style.right = ( window.innerWidth - ll.right ) + 'px';
        (head[i].style.width = list[i].offsetWidth + 'px');
      }
    }
  }
  componentWillUnmount(){
    window.removeEventListener("scroll", this.decapitate);
    //window.removeEventListener("scroll", options, options);
  }
  filterText = (evt) => {
		this.setState({filterText : evt.target.value});
  }
  addFilter = (new_filter, target) => {
    var filter = this.state.filter;
    filter.forEach((filt, j) => {
      if(filt.name === new_filter){
        var k = filt.active.indexOf(target);
        if(k >= 0){
          filter[j].active = [];
        }
        else {
          filter[j].active = [target];
        }
      }
    });
    this.setState({filter: filter});
    if (typeof this.props.sortAction === 'function'){
      this.props.sortAction(this.state.sortList, filter);
    }
    console.log('---!!!');
  }
  filterAction = ( filter ) => {
    if (typeof this.props.sortAction === 'function'){
      this.props.sortAction(this.state.sortList, filter);
    }
  }
  getFilter = () => {
    return this.state.filter;
  }
  tableSort = ( field , evt ) => {
    var sortList = this.state.sortList;
    var found = false;
    sortList.some((sortItem, i ) => {
      if(sortItem.field === field && sortItem.order === 1){

        sortList[i].order = -1;
        return found = true;

      }
      else if (sortItem.field === field){

        sortList.splice(i,1);
        return found = true;
      }
      return false;
    });
    if (!found) {
      sortList.unshift({field:field, order: 1});
    }
    var sort_str = '';
    sortList.forEach(_sortList => {
       sort_str += sort_str ? ',' : '';
       sort_str += _sortList.field+ '=' + _sortList.order;
    });
    this.setState({ sortList: sortList });
    if(typeof this.props.sortAction === 'function'){
      this.props.sortAction(sortList, this.state.filter);
    }
    this.props.root.sort_str='[' + sort_str + ']';
  }
  rowClick = ( obj ) => {
    this.props.clickAction.bind(this, this.props.root, obj)();
  }
  dataSort(sortList,a,b){
      var nx = 0;
        if(sortList.length){
        sortList.reverse().forEach(sl => {
            if(a['name'] === b['name'] &&  a.sku !== b.sku){
            }
            if (a[sl.field] < b[sl.field]){
               nx = -1 * sl.order;
            }
            else if (a[sl.field] > b[sl.field]){
               nx = 1 * sl.order;
            }
       });
     }
     else {
            if (a.id > b.id){
               nx = -1;
            }
            else if (a.id < b.id){
               nx = 1;
            }

     }
     return nx;
  }
  check = (obj, e) => {
    if(typeof this.props.checkAction === 'function') {
       this.props.checkAction(obj, e);
    }
  }
  render() {
    var header = [{direct:true}].concat(this.state.columns).map((col, j) => {
      var sortOrder;
      this.state.sortList.some((sortItem, i ) => {
        if (sortItem.field === col.field && sortItem.order === 1){
          sortOrder = 'up';
          return true;
        }
        else if (sortItem.field === col.field && sortItem.order === -1){
          sortOrder = 'down';
          return true;
        }
        return false;
      });

      var title = col.field;
      if(!col.show && !col.direct){
        return false;
      }
      else if( col.field ){
        if (col.title){
          title = col.title;
        }
        return <th className={sortOrder} onClick={this.tableSort.bind(this, col.field )} key={j}>{title}</th>
      }
      else if( col.title ){
        title = col.title;
        return <th key={j}>{title}</th>
      }
      else if(this.props.selectable) {
        return <th className={sortOrder} onClick={this.tableSort.bind(this, col.field )} key={j}>{col.field}</th>
      }
      else {
        return false;
      }
    });

    var newList = [];
    var fullList= [];
    if(this.props.display.items && this.props.display.items.list){
      fullList = this.props.display.items.list.sort(this.dataSort.bind(this,this.state.sortList));
    }
    fullList.some((obj, i) => {
      if (newList.length > 50000) {
        return true;
      }
      var show = this.state.str_filter(obj,this.state.filterText);
      this.state.filter.forEach(filter => {
        if(show){
          show = filter.test(obj, filter.active) ;
        }
      });
      if(show){
        newList.push(obj);
      }
      return false;
    })

    var body = newList.map(( obj, i ) => {

      var Columns = [{direct:<input type="checkbox" className="lineSelect" data-obj_id={obj.id} onClick={this.check.bind(this, obj)}  />}].concat(this.state.columns).map((col, j) => {
        var text;
        if(!col.show && !col.direct){
          return false;
        }
        else if(col.display && col.display_type === 'object' &&  (obj[col.field] || obj[col.field] === 0 || obj[col.field] === '0')){
          text = col.display.bind(this)(obj);
          return <td onClick={this.rowClick.bind(this, obj)} key={j}>{text}</td>
        }
        else if(col.display &&  (obj[col.field] || obj[col.field] === 0 || obj[col.field] === '0')){
          text = col.display.bind(this, obj[col.field])();
          return <td onClick={this.rowClick.bind(this, obj)} key={j}>{text}</td>
        }
        else if(col.display){
          text = col.display.bind(this)(obj);
          return <td onClick={this.rowClick.bind(this, obj)} key={j}>{text}</td>
        }
        else if(obj[col.field]){
          return <td onClick={this.rowClick.bind(this, obj)} key={j}>{obj[col.field]}</td>
        }
        else if(this.props.selectable && col.direct) {
          return <td key={j}>{col.direct}</td>
        }
        else {
          return <td onClick={this.rowClick.bind(this, obj)} key={j}></td>
        }
      });
      var style = {borderRight: 'none'};
      var colour;
      if(this.props.model.colourCode && (colour = this.props.model.colourCode(obj))){
        style = {borderRight: "solid " + colour + " 4px"}
      }
      var className;
      if(this.props.model.className){
        className = this.props.model.className(obj);
      }
      return <tr className={className} style={style} key={i}>{Columns}</tr>;
    });
    var id = 'List';
    if(this.props.id){
      id = this.props.id
    }
    if (this.props.mini !== 'true'){
      var filtering = '';
      if(Array.isArray(this.state.filter)){
          for(var i = 0 ; i < this.state.filter.length; i++){
               if(this.state.filter[i].active && this.state.filter[i].active.length){
                   filtering = ' filtering'
               }
          }
      }
        if(body.length === 0){
            console.log(this.props);
            if(this.props.search && this.props.display.items && this.props.display.items.list ){
                body = (<tr><td className="noDice" colSpan={header.length}>Unfortunately, we can't find any matching records. Please broaden any searches or filters.</td></tr>)
            }
        }
      return (
        <div className="List" id={id}>
          <div id="list_actions">
            <ColumnSelector list={this} root={this.props.root} model={this.props.model} />
            <ListFilter filterAction={this.filterAction} className={filtering} list={this} root={this.props.root} model={this.props.model}  options={this.props.options} />
          </div>
          <div className="FilterBar">
            <input id="filter_text" placeholder="Filter in page" onChange={this.filterText} value={this.state.filterText} />
            <button id="filter_btn" onClick={this.clearFilter}><i className="material-icons">close</i></button>
          </div>
          <PageState setPage={this.props.setPage} show={this.props.showState} display={this.props.display} />
          <table>
            <thead style={{display: 'none'}}><tr>{header}</tr></thead>
            <thead><tr>{header}</tr></thead>
            <tbody>{body}</tbody>
          </table>
        </div>
      );
    }
    else {
      var ooo;
      if(this.props.item){
        ooo = newList.map(this.props.item.bind(this, this.rowClick, this.props.current));
      }

      return (
        <div className="MiniList">
          <div className="FilterBar">
            <input id="filter_text" placeholder="Filter" onChange={this.filterText} value={this.state.filterText} />
            <button id="filter_btn"><i className="material-icons">search</i></button>
          </div>
          <Scrollbars style={{ width: '100%' }}>
          {ooo}
          </Scrollbars>
        </div>
      );
    }
    //this.decapitate();
 }
}

export default List;



// WEBPACK FOOTER //
// ./src/List.js